<div class="account-pages"></div>
<div class="wrapper-page">
  <div class="card">
    <div class="card-body">
      <app-spinner type="normal" [isSpinnerVisible]="formSubmitted"></app-spinner>
      <h3 class="text-center m-0 login-logo-wrap">
        <a href="javascript:;" class="logo logo-admin"><img src="assets/img/logo1.png" height="80" alt="logo"></a>
      </h3>
      <div class="p-3">
        <h4 class="text-muted font-18 m-b-5 text-center">Welcome Back !</h4>
        <p class="text-muted text-center">Sign in to continue to Dashboard.</p>
        <div class="alert alert-danger" *ngIf="formattedErrors.length > 0">
          <p *ngFor="let error of formattedErrors">
            <ng-container *ngIf="error != '' && error != 'invalid_grant'">
            {{ error }}
            </ng-container>
          </p>
        </div>
        <form class="form-horizontal m-t-30" [formGroup]="authForm" (ngSubmit)="submitForm()">
          <div class="form-group">
            <label for="username">Username</label> 
            <input type="text" class="form-control" formControlName="username" id="username" placeholder="Enter username">
            <app-validation-errors [submitted]="invalidFormData" [control]="authForm.get('username')"></app-validation-errors>
          </div>
          <div class="form-group">
            <label for="userpassword">Password</label> 
            <input type="password" class="form-control" formControlName="password" id="userpassword" placeholder="Enter password">
            <app-validation-errors [submitted]="invalidFormData" [control]="authForm.get('password')"></app-validation-errors>
          </div>
          <div class="form-group row m-t-20">
            <div class="col-6">
              <div class="custom-control custom-checkbox d-none">
                <input type="checkbox" class="custom-control-input" id="customControlInline"> 
                <label class="custom-control-label" for="customControlInline">Remember me</label>
              </div>
            </div>
            <div class="col-6 text-right">
              <button class="btn btn-primary px-5" type="submit">Log In</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>